module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح.81c9b4f5.png";